import {useCallback, useContext, useState} from "react";
import {imbalanceService} from "../../components/shared/ImbalanceService";
import SnackbarContext from "../../providers/snackbar-context";

const REPORT_LOCATION = "ELC";

export function useExportPersistentImbalances() {
    const snackbarCtx = useContext(SnackbarContext);
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = useCallback(async () => {
        setIsExporting(true);
        try {
            const inventoryReportsResponse = await imbalanceService.getInventoryReports();
            const elcBalancingReports = inventoryReportsResponse?.data?.getInventoryReports?.balancingReports
                ?.find((group: {location: string}) => group.location === REPORT_LOCATION)
                ?.reports ?? [];
            const latestReport = elcBalancingReports[0];

            if (!latestReport?.preSignedUrl) {
                snackbarCtx.displayMsg("No persistent-imbalances report available yet", "warning");
                return;
            }

            const csvBlob = await (await fetch(latestReport.preSignedUrl)).blob();
            const fileName = latestReport.path?.split("/").pop() ?? "persistent-imbalances.csv";

            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(csvBlob);
            downloadLink.download = fileName;
            downloadLink.click();
            URL.revokeObjectURL(downloadLink.href);
        } catch (error) {
            snackbarCtx.displayMsg("Failed to download persistent imbalances", "error");
        } finally {
            setIsExporting(false);
        }
    }, [snackbarCtx]);

    return {handleExport, isExporting};
}
